module.exports = __webpack_public_path__ + "media/images/empty/text-e6369943ae9c5ed15787cb8a00602cce.svg";